export const Logo = ({ className = "", showText = true }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg width="34" height="34" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="ApexLink logo">
        {/* Chevron "A" apex */}
        <path d="M20 4 L34 30 H26 L20 17 L14 30 H6 L20 4 Z" fill="#E4FF00" />
        {/* Linking nodes */}
        <circle cx="13" cy="35" r="3" fill="#F5F5F5" />
        <circle cx="27" cy="35" r="3" fill="#F5F5F5" />
        <line x1="13" y1="35" x2="27" y2="35" stroke="#E4FF00" strokeWidth="1.6" />
      </svg>
      {showText && (
        <div className="leading-none">
          <span className="font-display text-lg font-bold tracking-tight text-white">APEXLINK</span>
          <span className="block font-mono text-[9px] tracking-[0.35em] text-neon">LOGISTICS CORP.</span>
        </div>
      )}
    </div>
  );
};
